/* eslint no-console: 0 */
/* global axios */
/* eslint no-undef: "error" */
/* eslint no-unused-expressions: ["error", { "allowShortCircuit": true }] */
import endPoints from './endPoints';

export default {
  fetchFacebookPages(token, accountId) {
    const urlData = endPoints('fetchFacebookPages');
    urlData.params.omniauth_token = token;
    return axios.post(urlData.url(accountId), urlData.params);
  },
  fetchFacebookPageId(token, accountId, pageId) {
    const urlData = endPoints('fetchFacebookPageId');
    urlData.params.omniauth_token = token;
    urlData.params.fb_page_id = pageId;
    return axios.post(urlData.url(accountId), urlData.params);
  },
};
